import React, { Component } from "react";

import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";

import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Bulkquoteaddonrequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      touched: {}, // Track which fields have been touched

      filteredData: null,

      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.bulkquoteaddonrequest_Id,

          sortable: true,

          cell: (row) => <span>{row.bulkquoteaddonrequest_Id}</span>,
        },

        {
          name: "Company Id",

          selector: (row, i) => row.companyId,

          sortable: true,

          cell: (row) => <span>{row.companyId}</span>,
        },

        {
          name: "Member Id",

          selector: (row, i) => row.memberId,

          sortable: true,

          cell: (row) => <span>{row.memberId}</span>,
        },

        {
          name: "Addon Code",

          selector: (row, i) => row.addonCode,

          sortable: true,

          cell: (row) => <span>{row.addonCode}</span>,
        },

        {
          name: "Addon Value",

          selector: (row, i) => row.addonValue,

          sortable: true,

          cell: (row) => <span>{row.addonValue}</span>,
        },

        {
          name: "Bulkquote Request Id",

          selector: (row, i) => row.bulkquoteRequestId,

          sortable: true,

          cell: (row) => <span>{row.bulkquoteRequestId}</span>,
        },

        {
          name: "Employee Id",

          selector: (row, i) => row.employeeId,

          sortable: true,

          cell: (row) => <span>{row.employeeId}</span>,
        },

        {
          name: "Premium Generation Status",

          selector: (row, i) => row.premiumGenerationStatus,

          sortable: true,

          cell: (row) => <span>{row.premiumGenerationStatus}</span>,
        },

        {
          name: "Addon Premium",

          selector: (row, i) => row.addonPremium,

          sortable: true,

          cell: (row) => <span>{row.addonPremium}</span>,
        },

        {
          name: "Sum Insured",

          selector: (row, i) => row.sumInsured,

          sortable: true,

          cell: (row) => <span>{row.sumInsured}</span>,
        },

        {
          name: "Zone",

          selector: (row, i) => row.zone,

          sortable: true,

          cell: (row) => <span>{row.zone}</span>,
        },

        {
          name: "Member Coverage Status",
          selector: (row, i) => row.memberCoverageStatus,
          sortable: true,
          cell: (row) => <span>{row.memberCoverageStatus}</span>,
        },
        {
          name: "Coverage Family Definition",
          selector: (row, i) => row.coverageFamilyDefinition,
          sortable: true,
          cell: (row) => <span>{row.coverageFamilyDefinition}</span>,
        },
        {
          name: "Set Zone Status",
          selector: (row, i) => row.setZoneStatus,
          sortable: true,
          cell: (row) => <span>{row.setZoneStatus}</span>,
        },
        {
          name: "Set Premium Status",
          selector: (row, i) => row.setPremiumStatus,
          sortable: true,
          cell: (row) => <span>{row.setPremiumStatus}</span>,
        },
        {
          name: "Eldest Age",
          selector: (row, i) => row.eldestAge,
          sortable: true,
          cell: (row) => <span>{row.eldestAge}</span>,
        },
        {
          name: "Set Age Status",
          selector: (row, i) => row.setAgeStatus,
          sortable: true,
          cell: (row) => <span>{row.setAgeStatus}</span>,
        }, //***tableClms

        {
          name: "Actions",

          sortable: false,

          cell: (row) => (
            <div>
              {/* edit button and delete button */}

              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.BulkquoteaddonrequesteditHandler(row)}
                className="bi bi-pen"
              ></Button>

              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,

      itemsPerPage: 10,

      isEditing: false,

      bulkquoteaddonrequest_Id: "",

      companyId: "",

      memberId: "",

      addonCode: "",

      addonValue: "",

      bulkquoteRequestId: "",

      employeeId: "",

      premiumGenerationStatus: "",

      addonPremium: "",

      sumInsured: "",

      zone: "",

      memberCoverageStatus: "",
      coverageFamilyDefinition: "",
      setZoneStatus: "",
      setPremiumStatus: "",
      eldestAge: "",
      setAgeStatus: "", //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic

  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;

    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions

    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,

            parseInt(validationOptions.maxLength),

            fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }

        break;

      case "mail":

      case "email":
        validationResult = ValidationUtils.validateEmail(value);

        break;

      case "telephone":

      case "phone":
        validationResult = ValidationUtils.validatePhone(value);

        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,

          fieldDisplayName
        );

        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);

        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);

        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);

        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);

        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,

            message: "Password must be at least 6 characters long",
          };
        }

        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation

    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,

        fieldDisplayName
      );
    }

    const errors = { ...this.state.errors };

    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });

    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation

  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,

      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched

    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation

  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });

    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields

  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation

    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission

  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "companyId",

        inputType: "Text",

        displayName: "Company Id",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "memberId",

        inputType: "Text",

        displayName: "Member Id",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "addonCode",

        inputType: "Text",

        displayName: "Addon Code",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "addonValue",

        inputType: "Text",

        displayName: "Addon Value",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "bulkquoteRequestId",

        inputType: "Text",

        displayName: "Bulkquote Request Id",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "employeeId",

        inputType: "Text",

        displayName: "Employee Id",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "premiumGenerationStatus",

        inputType: "Text",

        displayName: "Premium Generation Status",

        validationOptions: { isRequired: false },
      },

      {
        fieldName: "addonPremium",

        inputType: "Text",

        displayName: "Addon Premium",

        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];

      this.validateField(config.fieldName, value, config);
    });

    const touched = {};

    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });

    this.setState({ touched });
  };

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,

      errors: {},

      touched: {},

      companyId: "",

      memberId: "",

      addonCode: "",

      addonValue: "",

      bulkquoteRequestId: "",

      employeeId: "",

      premiumGenerationStatus: "",

      addonPremium: "",

      sumInsured: "",

      zone: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,

      isEditing: false,

      errors: {},

      touched: {},

      companyId: "",

      memberId: "",

      addonCode: "",

      addonValue: "",

      bulkquoteRequestId: "",

      employeeId: "",

      premiumGenerationStatus: "",

      addonPremium: "",

      sumInsured: "",

      zone: "",
    });
  };

  // Enhanced toast notifications

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg);

        break;

      default:
        toast.info(msg);
    }
  };

  BulkquoteaddonrequesteditHandler = (row) => {
    this.setState({
      isEditing: true,

      show: true,

      bulkquoteaddonrequest_Id: row.bulkquoteaddonrequest_Id,

      companyId: row.companyId,

      memberId: row.memberId,

      addonCode: row.addonCode,

      addonValue: row.addonValue,

      bulkquoteRequestId: row.bulkquoteRequestId,

      employeeId: row.employeeId,

      premiumGenerationStatus: row.premiumGenerationStatus,

      addonPremium: row.addonPremium,

      sumInsured: row.sumInsured,

      zone: row.zone,

      memberCoverageStatus: row.memberCoverageStatus,
      coverageFamilyDefinition: row.coverageFamilyDefinition,
      setZoneStatus: row.setZoneStatus,
      setPremiumStatus: row.setPremiumStatus,
      eldestAge: row.eldestAge,
      setAgeStatus: row.setAgeStatus, //***editstate

      errors: {},

      touched: {},
    });
  };

  BulkquoteaddonrequestfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Bulkquoteaddonrequest/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })

      .catch((error) => {
        console.error("Fetch error:", error);

        this.showToast("Failed to load data", "error");
      });
  };

  BulkquoteaddonrequestsubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("companyId", this.state.companyId);

    formData.append("memberId", this.state.memberId);

    formData.append("addonCode", this.state.addonCode);

    formData.append("addonValue", this.state.addonValue);

    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);

    formData.append("employeeId", this.state.employeeId);

    formData.append(
      "premiumGenerationStatus",

      this.state.premiumGenerationStatus
    );

    formData.append("addonPremium", this.state.addonPremium);

    formData.append("sumInsured", this.state.sumInsured);

    formData.append("zone", this.state.zone);

    formData.append("memberCoverageStatus", this.state.memberCoverageStatus);

    formData.append(
      "coverageFamilyDefinition",
      this.state.coverageFamilyDefinition
    );

    formData.append("setZoneStatus", this.state.setZoneStatus);

    formData.append("setPremiumStatus", this.state.setPremiumStatus);

    formData.append("eldestAge", this.state.eldestAge);

    formData.append("setAgeStatus", this.state.setAgeStatus);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Bulkquoteaddonrequest/add", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.BulkquoteaddonrequestfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            companyId: "",

            memberId: "",

            addonCode: "",

            addonValue: "",

            bulkquoteRequestId: "",

            employeeId: "",

            premiumGenerationStatus: "",

            addonPremium: "",

            sumInsured: "",

            zone: "",
          });
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Submit error:", error);

        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  };

  BulkquoteaddonrequestupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append(
      "bulkquoteaddonrequest_Id",

      this.state.bulkquoteaddonrequest_Id
    );

    formData.append("companyId", this.state.companyId);

    formData.append("memberId", this.state.memberId);

    formData.append("addonCode", this.state.addonCode);

    formData.append("addonValue", this.state.addonValue);

    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);

    formData.append("employeeId", this.state.employeeId);

    formData.append(
      "premiumGenerationStatus",

      this.state.premiumGenerationStatus
    );

    formData.append("addonPremium", this.state.addonPremium);

    formData.append("sumInsured", this.state.sumInsured);

    formData.append("zone", this.state.zone);

    formData.append("memberCoverageStatus", this.state.memberCoverageStatus);

    formData.append(
      "coverageFamilyDefinition",
      this.state.coverageFamilyDefinition
    );

    formData.append("setZoneStatus", this.state.setZoneStatus);

    formData.append("setPremiumStatus", this.state.setPremiumStatus);

    formData.append("eldestAge", this.state.eldestAge);

    formData.append("setAgeStatus", this.state.setAgeStatus);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Bulkquoteaddonrequest/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.BulkquoteaddonrequestfetchHandler();

          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Update error:", error);

        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  };

  componentDidMount() {
    this.BulkquoteaddonrequestfetchHandler();

    //***componentDidMount
  }

  handlecompanyIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ companyId: fieldValue });
  };

  handlesumInsuredChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ sumInsured: fieldValue });
  };

  handlezoneChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ zone: fieldValue });
  };

  handlememberIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ memberId: fieldValue });
  };

  handleaddonCodeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ addonCode: fieldValue });
  };

  handleaddonValueChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ addonValue: fieldValue });
  };

  handlebulkquoteRequestIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ bulkquoteRequestId: fieldValue });
  };

  handleemployeeIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ employeeId: fieldValue });
  };

  handlepremiumGenerationStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ premiumGenerationStatus: fieldValue });
  };

  handleaddonPremiumChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ addonPremium: fieldValue });
  };

  handlememberCoverageStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ memberCoverageStatus: fieldValue });
  };
  handlecoverageFamilyDefinitionChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ coverageFamilyDefinition: fieldValue });
  };
  handlesetZoneStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ setZoneStatus: fieldValue });
  };
  handlesetPremiumStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ setPremiumStatus: fieldValue });
  };
  handleeldestAgeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ eldestAge: fieldValue });
  };
  handlesetAgeStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ setAgeStatus: fieldValue });
  }; //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this bulkquoteaddonrequest?`
      )
    ) {
      return;
    }

    var formData = new FormData();

    formData.append("bulkquoteaddonrequest_Id", row.bulkquoteaddonrequest_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Bulkquoteaddonrequest/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.BulkquoteaddonrequestfetchHandler();
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Delete error:", error);

        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  // Helper method to render error message

  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;

    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>

          {errors[fieldName]}
        </div>
      );
    }

    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options

  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;

    const value = this.state[fieldName] || "";

    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":

      case "dob_adult":

      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );

        break;

      case "telephone":

      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );

        break;

      case "mail":

      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );

        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );

        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );

        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,

                e.target.value.toUpperCase(),

                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );

        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,

                e.target.value.replace(/\D/g, ""),

                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );

        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}

            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>

        <Col lg="8" md="8">
          {inputElement}

          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Bulkquote Addon Request
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}

                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Bulkquoteaddonrequest
                          </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}

                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>

                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompanyIdChange}
                                        className="form-control"
                                        name="companyId"
                                        value={this.state.companyId}
                                        required="required"
                                        placeholder="Enter Company Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlememberIdChange}
                                        className="form-control"
                                        name="memberId"
                                        value={this.state.memberId}
                                        required="required"
                                        placeholder="Enter Member Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.memberId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Addon Code
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleaddonCodeChange}
                                        className="form-control"
                                        name="addonCode"
                                        value={this.state.addonCode}
                                        required="required"
                                        placeholder="Enter Addon Code"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.addonCode}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Addon Value
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleaddonValueChange}
                                        className="form-control"
                                        name="addonValue"
                                        value={this.state.addonValue}
                                        required="required"
                                        placeholder="Enter Addon Value"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.addonValue}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Bulkquote Request Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlebulkquoteRequestIdChange
                                        }
                                        className="form-control"
                                        name="bulkquoteRequestId"
                                        value={this.state.bulkquoteRequestId}
                                        required="required"
                                        placeholder="Enter Bulkquote Request Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.bulkquoteRequestId
                                      }{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Employee Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleemployeeIdChange}
                                        className="form-control"
                                        name="employeeId"
                                        value={this.state.employeeId}
                                        required="required"
                                        placeholder="Enter Employee Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.employeeId}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Premium Generation Status
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this
                                            .handlepremiumGenerationStatusChange
                                        }
                                        className="form-control"
                                        name="premiumGenerationStatus"
                                        value={
                                          this.state.premiumGenerationStatus
                                        }
                                        required="required"
                                        placeholder="Enter Premium Generation Status"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors
                                          .premiumGenerationStatus
                                      }{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Addon Premium
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleaddonPremiumChange}
                                        className="form-control"
                                        name="addonPremium"
                                        value={this.state.addonPremium}
                                        required="required"
                                        placeholder="Enter Addon Premium"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.addonPremium}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Sum Insured
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlesumInsuredChange}
                                        className="form-control"
                                        name="sumInsured"
                                        value={this.state.sumInsured}
                                        required="required"
                                        placeholder="Enter Sum Insured"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.sumInsured}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Zone
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlezoneChange}
                                        className="form-control"
                                        name="zone"
                                        value={this.state.zone}
                                        required="required"
                                        placeholder="Enter zone"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.zone}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member Coverage Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlememberCoverageStatusChange
                                        }
                                        className="form-control"
                                        name="memberCoverageStatus"
                                        value={this.state.memberCoverageStatus}
                                        required="required"
                                        placeholder="Enter Member Coverage Status"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Coverage Family Definition
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this
                                            .handlecoverageFamilyDefinitionChange
                                        }
                                        className="form-control"
                                        name="coverageFamilyDefinition"
                                        value={
                                          this.state.coverageFamilyDefinition
                                        }
                                        required="required"
                                        placeholder="Enter Coverage Family Definition"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Set Zone Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesetZoneStatusChange
                                        }
                                        className="form-control"
                                        name="setZoneStatus"
                                        value={this.state.setZoneStatus}
                                        required="required"
                                        placeholder="Enter Set Zone Status"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Set Premium Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesetPremiumStatusChange
                                        }
                                        className="form-control"
                                        name="setPremiumStatus"
                                        value={this.state.setPremiumStatus}
                                        required="required"
                                        placeholder="Enter Set Premium Status"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Eldes tAge
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleeldestAgeChange}
                                        className="form-control"
                                        name="eldestAge"
                                        value={this.state.eldestAge}
                                        required="required"
                                        placeholder="Enter Eldest Age"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Set Age Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlesetAgeStatusChange}
                                        className="form-control"
                                        name="setAgeStatus"
                                        value={this.state.setAgeStatus}
                                        required="required"
                                        placeholder="Enter Set Age Status"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.BulkquoteaddonrequestsubmitHandler
                                  }
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}

                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Bulkquoteaddonrequest
                            </Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}

                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>

                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Company Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlecompanyIdChange}
                                          className="form-control"
                                          name="companyId"
                                          value={this.state.companyId}
                                          required="required"
                                          placeholder="Enter Company Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.companyId}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlememberIdChange}
                                          className="form-control"
                                          name="memberId"
                                          value={this.state.memberId}
                                          required="required"
                                          placeholder="Enter Member Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberId}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Addon Code
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleaddonCodeChange}
                                          className="form-control"
                                          name="addonCode"
                                          value={this.state.addonCode}
                                          required="required"
                                          placeholder="Enter Addon Code"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.addonCode}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Addon Value
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleaddonValueChange}
                                          className="form-control"
                                          name="addonValue"
                                          value={this.state.addonValue}
                                          required="required"
                                          placeholder="Enter Addon Value"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.addonValue}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Bulkquote Request Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlebulkquoteRequestIdChange
                                          }
                                          className="form-control"
                                          name="bulkquoteRequestId"
                                          value={this.state.bulkquoteRequestId}
                                          required="required"
                                          placeholder="Enter Bulkquote Request Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.bulkquoteRequestId
                                        }{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employee Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleemployeeIdChange}
                                          className="form-control"
                                          name="employeeId"
                                          value={this.state.employeeId}
                                          required="required"
                                          placeholder="Enter Employee Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.employeeId}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Premium Generation Status
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handlepremiumGenerationStatusChange
                                          }
                                          className="form-control"
                                          name="premiumGenerationStatus"
                                          value={
                                            this.state.premiumGenerationStatus
                                          }
                                          required="required"
                                          placeholder="Enter Premium Generation Status"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors
                                            .premiumGenerationStatus
                                        }{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Addon Premium
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleaddonPremiumChange
                                          }
                                          className="form-control"
                                          name="addonPremium"
                                          value={this.state.addonPremium}
                                          required="required"
                                          placeholder="Enter Addon Premium"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.addonPremium}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Sum Insured
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlesumInsuredChange}
                                          className="form-control"
                                          name="sumInsured"
                                          value={this.state.sumInsured}
                                          required="required"
                                          placeholder="Enter Sum Insured"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.sumInsured}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Zone
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlezoneChange}
                                          className="form-control"
                                          name="zone"
                                          value={this.state.zone}
                                          required="required"
                                          placeholder="Enter zone"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.zone}{" "}
                                      </div>
                                    </Row>

                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Coverage Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handlememberCoverageStatusChange
                                          }
                                          className="form-control"
                                          name="memberCoverageStatus"
                                          value={
                                            this.state.memberCoverageStatus
                                          }
                                          required="required"
                                          placeholder="Enter Member Coverage Status"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Coverage Family Definition
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handlecoverageFamilyDefinitionChange
                                          }
                                          className="form-control"
                                          name="coverageFamilyDefinition"
                                          value={
                                            this.state.coverageFamilyDefinition
                                          }
                                          required="required"
                                          placeholder="Enter Coverage Family Definition"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Set Zone Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlesetZoneStatusChange
                                          }
                                          className="form-control"
                                          name="setZoneStatus"
                                          value={this.state.setZoneStatus}
                                          required="required"
                                          placeholder="Enter Set Zone Status"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Set Premium Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlesetPremiumStatusChange
                                          }
                                          className="form-control"
                                          name="setPremiumStatus"
                                          value={this.state.setPremiumStatus}
                                          required="required"
                                          placeholder="Enter Set Premium Status"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Eldes tAge
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleeldestAgeChange}
                                          className="form-control"
                                          name="eldestAge"
                                          value={this.state.eldestAge}
                                          required="required"
                                          placeholder="Enter Eldest Age"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Set Age Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlesetAgeStatusChange
                                          }
                                          className="form-control"
                                          name="setAgeStatus"
                                          value={this.state.setAgeStatus}
                                          required="required"
                                          placeholder="Enter Set Age Status"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>

                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.BulkquoteaddonrequestupdateHandler
                                    }
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />

                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
